export default __webpack_public_path__ + "static/media/studioweb-bg.b4443301.png";